import React from "react";
import "./Wallet.css";
import { Box, Heading, Button } from "@chakra-ui/react";
import { useSelector } from "react-redux";

const Wallet = () => {
  const userData = useSelector((storeData) => {
    return storeData.UserReducer.userData;
  });
  return (
    <div>
      <div>
        <Heading fontSize="28px" color="#333333">
          Hello, {userData.name}
        </Heading>
      </div>
      <div id="profile_Desc">
        <Box
          bg="white"
          w="31%"
          color="#333333"
          p="22px"
          borderRadius="2px"
          boxShadow="2px 4px 8px 0 rgb(0 0 0 / 10%)"
          border="solid 1px #d6d6d6"
        >
          <Box
            bg="black"
            borderRadius="50%"
            w="43px"
            height="43px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            margin="15px 0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="42"
              viewBox="0 0 55 46"
            >
              <g
                fill="none"
                stroke="#ffb121"
                strokeWidth=".6"
                fillRule="evenodd"
              >
                <path d="M27.9 16.2c-.6-.2-1.1 0-1.4.6l-9.6 24.8L2.6 6.5c-.3-.6-.7-1-1.2-.9-.3 0-.6.2-.8.5-.2.3-.2.7-.1 1 .2.8.6 1.5.9 2.2.2.4.4.8.5 1.1l7.2 17.7c2.3 5.5 4.5 11.1 6.8 16.6.1.2.2.3.3.5l.1.1.2.2h1.1l.2-.3c0-.1.1-.1.1-.2.1-.1.2-.3.3-.5 2.9-7.5 5.8-15.1 8.7-22.6l.9-2.3c.3-.7.6-1.4.8-2.1.2-.5-.1-1.1-.7-1.3zm26.92-9.525c-.1-.3-.3-.5-.6-.6-.6-.2-1.1 0-1.4.6l-15.2 35.3-7.4-19.9v-.1c-.1-.2-.1-.3-.2-.5-.2-.5-.7-.7-1.3-.5-.5.2-.8.6-.7 1.2 0 .2.1.3.1.5l.4 1.2c2.6 7.1 5.3 14.2 7.9 21.3.1.2.2.4.3.5l.1.1.2.2h1l.2-.2.1-.1c.1-.1.2-.3.3-.5 4.6-10.7 9.2-21.5 13.9-32.2l1.5-3.4c.3-.6.5-1.3.8-1.9.1-.4.1-.7 0-1z"></path>
                <path d="M17.3 30.2c.3-.1.6-.4.7-.8 2.6-6.7 5.2-13.5 7.8-20.2l1.7-4.4c0-.1.1-.1.1-.2l9.2 24.8c.1.3.3.9 1.1.9.7 0 1-.6 1.1-.9L49.7 4c.2-.4.2-.8.1-1.1-.1-.2-.2-.4-.6-.6-.6-.2-1.2.1-1.4.7L38 26.1 28.7 1.2c-.3-.9-.9-.9-1.3-.8-.6.1-.8.6-.9.9l-7.9 20.2-2 5.2c-.3.6-.5 1.3-.7 1.9-.1.4 0 .8.1 1.1.3.6 1 .7 1.3.5zm-4.8-9.1c.1.3.2.6.4.9.2.4.5.6 1 .6h.2c.3-.1.8-.3.9-1v-.1l-.1-.2c0-.1-.1-.2-.1-.3L9.4 7.5c-.6-1.4-1.1-2.8-1.7-4.3-.3-.8-1-.8-1.2-.8-.3.1-.6.2-.7.5-.2.3-.2.7 0 1.1l6.7 17.1z"></path>
                <path d="M12.5 21.1c.1.3.2.6.4.9.2.4.5.6 1 .6h.2c.3-.1.8-.3.9-1v-.1l-.1-.2c0-.1-.1-.2-.1-.3L9.4 7.5c-.6-1.4-1.1-2.8-1.7-4.3-.3-.8-1-.8-1.2-.8-.3.1-.6.2-.7.5-.2.3-.2.7 0 1.1l6.7 17.1zM28.7 1.4c-.3-.9-.9-.9-1.3-.8-.6.1-.8.6-.9.9l-7.9 20.2-2 5.2c-.3.6-.5 1.3-.7 1.9-.1.4 0 .8.1 1.1.2.4.8.5 1.2.4.3-.1.6-.4.7-.8 2.6-6.7 5.2-13.5 7.8-20.2l1.7-4.4c0-.1.1-.1.1-.2l7 19 2-.9-7.8-21.4zm21 2.7c.2-.4.2-.8.1-1.1-.1-.2-.2-.4-.6-.6-.6-.2-1.2.1-1.4.7L40.2 21l2.9-1.3 6.6-15.6z"></path>
                <path d="M30.22 22.177v-.1c-.1-.2-.1-.3-.2-.5-.2-.5-.7-.7-1.3-.5-.5.2-.8.6-.7 1.2 0 .2.1.3.1.5l.4 1.2c.3.9.6 1.7 1 2.6l2-.9-1.3-3.5zM51 16.1c.5-1.2 1.1-2.5 1.6-3.7L54.1 9c.3-.6.5-1.3.8-1.9.1-.3.1-.6 0-.9-.1-.3-.3-.5-.6-.6-.6-.2-1.1 0-1.4.6l-4.8 11.2 2.9-1.3zM2.6 6.5c-.3-.6-.7-1-1.2-.9-.3 0-.6.2-.8.5-.2.3-.2.7-.1 1 .2.8.6 1.5.9 2.2.2.4.4.8.5 1.1l7.2 17.7c.8 2 1.7 4.1 2.5 6.1l2-.9-11-26.8zM26.8 22l.9-2.3c.3-.7.6-1.4.8-2.1.2-.6 0-1.2-.6-1.4-.6-.2-1.1 0-1.4.6l-5 12.8 2.8-1.3c.9-2 1.7-4.1 2.5-6.3z"></path>
              </g>
            </svg>
          </Box>
          <Heading fontSize="26px" marginBottom="10px" color="#222222">
            OYO Wizard
          </Heading>
          <span>
            OYO Wizard is our hospitality membership program. As a member, you
            will be entitled to additional discounts of up to 10% on OYO Wizard
            member hotels and will also enjoy exclusive benefits with our
            partner alliances.
          </span>
          <div>
            <Button bg="#1ab64f" color="white" margin="15px 0">
              Buy Membership
            </Button>
          </div>
        </Box>
        <Box
          bg="white"
          w="31%"
          color="#333333"
          p="22px"
          borderRadius="2px"
          boxShadow="2px 4px 8px 0 rgb(0 0 0 / 10%)"
          border="solid 1px #d6d6d6"
        >
          <Box
            borderRadius="50%"
            w="43px"
            height="43px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            margin="15px 0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="43"
              height="43"
              viewBox="0 0 43 43"
            >
              <g fill="none" fillRule="evenodd">
                <path
                  fill="#8391C2"
                  fillRule="nonzero"
                  d="M4.57 21.67c0-10.558 7.147-19.262 16.374-20.51-.75-.102-1.51-.16-2.285-.16C8.354 1 0 10.254 0 21.67c0 11.415 8.354 20.67 18.66 20.67.773 0 1.535-.059 2.284-.16C11.717 40.93 4.57 32.228 4.57 21.67"
                ></path>
                <path
                  fill="#F5F5F5"
                  fillRule="nonzero"
                  d="M4.568 22.408H0c.015.497.044.99.09 1.476h4.573c-.048-.487-.079-.98-.095-1.476m.175-3.691H.176c-.063.486-.109.98-.14 1.476h4.569c.032-.497.074-.99.138-1.476m.244 7.382H.417c.099.499.213.991.343 1.476h4.57c-.13-.485-.243-.977-.342-1.476m1.065 3.691H1.48c.194.503.409.994.637 1.476h4.57a21.565 21.565 0 01-.634-1.476m-.515-14.764H.974a21.89 21.89 0 00-.403 1.476h4.575c.116-.499.245-.993.392-1.476m1.518-3.691h-4.57c-.251.48-.488.972-.705 1.476h4.573c.216-.503.45-.996.702-1.476m3.108-4.429H5.589c-.434.47-.846.962-1.236 1.476h4.574c.39-.514.803-1.007 1.237-1.476m4.657-3.691h-4.58c-.778.435-1.524.928-2.236 1.476h4.577a18.41 18.41 0 012.239-1.476"
                  opacity=".815"
                ></path>
                <path
                  fill="#F5F5F5"
                  fillRule="nonzero"
                  d="M8.392 25.604H3.82c.354.511.727 1.004 1.121 1.476h4.575a20.7 20.7 0 01-1.124-1.476m-1.285 3.691A18.81 18.81 0 009.03 30.77h4.58c-.673-.448-1.32-.94-1.934-1.476H7.107z"
                  opacity=".815"
                ></path>
                <path
                  fill="white"
                  fillRule="nonzero"
                  stroke="#8391C2"
                  strokeWidth=".7"
                  d="M23.23 42.34c-10.306 0-18.66-9.255-18.66-20.67C4.57 10.254 12.924 1 23.23 1c10.305 0 18.659 9.254 18.659 20.67 0 11.415-8.354 20.67-18.66 20.67"
                ></path>
                <path
                  fill="#8391C2"
                  fillRule="nonzero"
                  d="M23.809 38.375h-.068c-.551 0-1.106-.032-1.65-.094a.77.77 0 01-.689-.85c.052-.418.447-.71.876-.666.482.056.974.084 1.463.084.436 0 .822.342.822.763a.746.746 0 01-.754.763m4.579-.822a.788.788 0 01-.737-.494.756.756 0 01.46-.983c.453-.166.905-.36 1.342-.578a.799.799 0 011.061.33.752.752 0 01-.342 1.028c-.49.244-.996.46-1.507.648a.796.796 0 01-.277.05M17.73 36.97a.802.802 0 01-.356-.083 15.137 15.137 0 01-1.425-.8.749.749 0 01-.227-1.056.805.805 0 011.09-.22c.412.26.841.502 1.274.715.388.19.543.65.346 1.026a.79.79 0 01-.702.418m15.836-2.716a.8.8 0 01-.555-.22.747.747 0 01-.004-1.08c.342-.334.675-.695.99-1.07a.806.806 0 011.107-.11.747.747 0 01.115 1.073 16.65 16.65 0 01-1.094 1.182.8.8 0 01-.56.225M12.92 33.18a.799.799 0 01-.61-.279 17.02 17.02 0 01-.975-1.27.75.75 0 01.213-1.06.802.802 0 011.093.205c.278.4.576.79.888 1.157a.748.748 0 01-.11 1.074.801.801 0 01-.5.173m24.108-3.921a.813.813 0 01-.314-.063.755.755 0 01-.408-1.006c.198-.438.378-.893.537-1.35a.795.795 0 01.997-.48.759.759 0 01.496.967c-.174.498-.37.995-.586 1.473a.792.792 0 01-.722.459M9.918 27.91a.788.788 0 01-.746-.517 18.185 18.185 0 01-.459-1.514.76.76 0 01.573-.924c.42-.104.85.146.955.556.12.467.262.935.422 1.389a.758.758 0 01-.49.968.797.797 0 01-.255.042m28.597-4.5l-.062-.003a.772.772 0 01-.724-.82c.037-.463.056-.936.056-1.403 0-.422.353-.788.787-.788.435 0 .788.317.788.738v.05c0 .507-.02 1.019-.06 1.52a.778.778 0 01-.785.705M8.91 21.955c-.435 0-.788-.333-.788-.755v-.016c0-.521.022-1.045.063-1.555a.782.782 0 01.848-.7.771.771 0 01.723.82c-.039.472-.059.954-.059 1.435a.783.783 0 01-.787.771m29.086-4.551a.783.783 0 01-.763-.576 16.67 16.67 0 00-.425-1.39.758.758 0 01.49-.97.791.791 0 011 .475c.175.493.33 1.001.462 1.51a.762.762 0 01-.57.927.756.756 0 01-.194.024m-28.09-1.387a.816.816 0 01-.253-.041.758.758 0 01-.493-.968c.174-.496.372-.992.588-1.472a.798.798 0 011.038-.393c.398.168.58.619.406 1.005-.2.44-.38.895-.54 1.35a.788.788 0 01-.745.519m25.569-4.116a.794.794 0 01-.653-.336 15.635 15.635 0 00-.89-1.154.748.748 0 01.107-1.075.805.805 0 011.109.104c.343.404.672.83.978 1.27a.75.75 0 01-.21 1.06.802.802 0 01-.441.13m-22.58-1.16a.8.8 0 01-.498-.173.747.747 0 01-.11-1.074c.347-.412.715-.809 1.095-1.179a.807.807 0 011.113-.003c.309.298.31.78.004 1.08-.343.334-.678.694-.994 1.069a.792.792 0 01-.61.28m18.176-3.076a.797.797 0 01-.428-.124c-.412-.26-.842-.5-1.277-.713a.752.752 0 01-.348-1.025.8.8 0 011.058-.337c.487.237.966.505 1.426.796a.75.75 0 01.23 1.056.791.791 0 01-.66.347M17.7 6.939a.79.79 0 01-.7-.417.752.752 0 01.344-1.027c.49-.242.998-.46 1.509-.644a.795.795 0 011.013.447.757.757 0 01-.462.983 13.1 13.1 0 00-1.346.575.8.8 0 01-.356.083m7.565-1.335a.746.746 0 01-.092-.006 12.84 12.84 0 00-1.433-.08c-.434 0-.804-.342-.804-.763s.336-.763.771-.763h.033c.537 0 1.08.03 1.615.09a.768.768 0 01.69.846.779.779 0 01-.78.676"
                ></path>
                <path
                  fill="#EE2A24"
                  d="M29.812 24.825c1.478-.078 2.615-1.415 2.532-2.98-.082-1.567-1.351-2.777-2.83-2.7-1.478.078-2.614 1.414-2.532 2.98.082 1.566 1.351 2.777 2.83 2.7zm-.202-3.852c.527-.028.98.403 1.01.962.028.558-.377 1.034-.904 1.062-.527.028-.979-.404-1.008-.962-.03-.558.375-1.035.902-1.062zm-9.913 4.382c1.478-.078 2.614-1.415 2.532-2.98-.082-1.567-1.352-2.777-2.83-2.7-1.478.078-2.614 1.414-2.532 2.98.082 1.566 1.352 2.777 2.83 2.7zm-.202-3.852c.527-.028.98.404 1.009.962.029.558-.376 1.034-.903 1.062-.527.028-.98-.404-1.008-.962-.03-.558.375-1.035.902-1.062zm5.053-.33l-.914-1.682-1.928.101 1.999 3.681.093 1.778 1.9-.1-.092-1.777 1.602-3.87-1.928.101-.732 1.769z"
                ></path>
              </g>
            </svg>
          </Box>
          <Heading fontSize="26px" marginBottom="10px" color="#222222">
            Your OYO Money
          </Heading>
          <p>
            OYO Money Balance: &nbsp;
            <strong>
              <span className="profile_Money_Details">₹519</span>
            </strong>
          </p>
          <p>
            Expired: &nbsp;
            <strong>
              <span className="profile_Money_Details">Nov 26, 2022</span>
            </strong>
          </p>
          <p>
            Usable this month: &nbsp;
            <strong>
              <span className="profile_Money_Details">
                ₹519 (max ₹25000 per month)
              </span>
            </strong>
          </p>
        </Box>
      </div>
    </div>
  );
};

export default Wallet;
